<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">
    <CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active ? '' : item.path"
      :active="item.active"
    >
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/router'

export default {
  name: 'AppBreadcrumb',
  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
			const user = JSON.parse(localStorage.getItem("user"))
      return router.currentRoute.value.matched.map((route) => {
				if(user.role === 'admin' && route.name === 'Home') {
					return {
						active: route.path === router.currentRoute.value.fullPath,
          name: route.name,
          path: `${router.options.history.base}/representatives`,
					}
				}
				else if((user.role === 'org_admin' || user.role === 'hr') && route.name === 'Home') {
					return {
						active: route.path === router.currentRoute.value.fullPath,
          name: route.name,
          path: `${router.options.history.base}/employee`,
					}
				}
				else if(user.role === 'rep' && route.name === 'Home') {
					return {
						active: route.path === router.currentRoute.value.fullPath,
          name: route.name,
          path: `${router.options.history.base}/sessions`,
					}
				}
        return {
					active:false,
          active: route.path === router.currentRoute.value.fullPath,
          name: route.name,
          path: `${router.options.history.base}${route.path}`,
        }
      })
    }

    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
			console.log({breadcrumbs:breadcrumbs.value})
    })

    return {
      breadcrumbs,
    }
  },
}
</script>
